export function isUrlAnImage(url) {
  return(url.match(/\.(jpeg|jpg|gif|png)$/) != null);
}